<span class="st-create-topic-full-screen__label">{{ languageSettings().PSTCreateNewTopicLabel }}</span>
<div class="st-create-topic-full-screen_content">
    <div
        class="st-create-topic-full-screen_content_header"
        [dir]="isRTL()">
        <st-topic-type
            class="st-topic-item-content-container-main__type"
            showAdd
            maxValuesToShow="10"
            [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicType)"
            [disabled]="cardDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicType]"
            [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicType]?.DefaultCaption"
            [value]="data()?.PSTTopicType"
            [required]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicType]?.Required"
            (changed)="updateTopic($event, pstFieldNames.PSTTopicType)" />
        <div class="st-create-topic-full-screen_content_header_top-row">
            <st-text-area-overlay
                #title
                required
                minRows="1"
                minHeight="1rem"
                class="st-create-topic-full-screen__title"
                panelClass="st-create-topic-full-screen__title"
                maxLength="50"
                disableNewLine
                maxOverlayRows="1"
                [textToHighlight]="textAreaOverlayHighlight()"
                [value]="data()?.Title"
                [disabled]="topicDisabled()"
                [label]="languageSettings().PSTWebSlugPlaceholder"
                [placeholder]="languageSettings().PSTWebSlugPlaceholder"
                (changed)="updateTopic($event, pstFieldNames.Title)" />
        </div>
        @if (globalTablesService?.FieldDefsDict[pstFieldNames?.Description]?.Required) {
            <div class="st-create-topic-full-screen_content_header_top-row">
                <st-text-area-overlay
                    class="st-create-topic-full-screen__description"
                    panelClass="st-create-topic-full-screen__description"
                    minRows="3"
                    minHeight="1rem"
                    [textToHighlight]="textAreaOverlayHighlight()"
                    [value]="data()?.Description"
                    [disabled]="topicDisabled()"
                    [required]="enforceRequiredFieldsOnCreate()"
                    [placeholder]="globalTablesService?.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
                    [label]="globalTablesService?.FieldDefsDict[pstFieldNames?.Description]?.DefaultCaption"
                    (changed)="updateTopic($event, pstFieldNames.Description)" />
            </div>
        }
        <div
            class="st-create-topic-full-screen_content_header_top-row"
            [dir]="isRTL()">
            <st-status
                class="st-topic-full-screen-main-content__options__container__status"
                [fieldName]="pstFieldNames.PSTTopicStatus"
                [value]="data()?.PSTTopicStatus"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStatus]"
                [placeholder]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.DefaultCaption"
                [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicStatus)"
                [data]="data()"
                [itemType]="data()?.PSTTopicStatus?.id"
                [statusFieldName]="pstFieldNames.PSTTopicStatus"
                [addEmptyOption]="!globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStatus]?.Required"
                (changed)="updateTopic($event, pstFieldNames.PSTTopicStatus)" />
            <st-date-time-picker
                class="st-create-topic-full-screen__date-picker"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.Required"
                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.TargetPublicationDate]?.DefaultCaption"
                [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.TargetPublicationDate]"
                [value]="data()?.[pstFieldNames.TargetPublicationDate]"
                (timezoneChange)="timezoneChanged(pstFieldNames.TargetPublicationDate, $event)"
                (changed)="updateTopic($event, pstFieldNames.TargetPublicationDate)" />
            <st-desk
                class="st-create-topic-full-screen__desk"
                [value]="data()?.PSTGroup"
                [data]="data()"
                [fieldName]="pstFieldNames?.PSTDesk"
                [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTDesk]"
                [itemList]="globalTablesService.getListItemsForDesk(data()?.Type)"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.Required"
                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTDesk]?.DefaultCaption"
                (changed)="updateTopic($event, pstFieldNames.PSTDesk)" />
            <st-staff-id-list
                class="st-create-topic-full-screen__topic-owner"
                [value]="data()?.PSTTopicOwner"
                [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicStoryOwner]"
                [required]="enforceRequiredFieldsOnCreate() && globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.Required"
                [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTopicStoryOwner]?.DefaultCaption"
                (changed)="updateTopic($event, pstFieldNames.PSTTopicStoryOwner)" />
        </div>
    </div>
    @if (showMatDivider()) {
        <mat-divider />
    }
    <div
        #scrollableDiv
        class="st-create-topic-full-screen_content_main"
        [dir]="isRTL()">
        <div class="st-create-topic-full-screen_content_main_options">
            @for (item of properties(); track item.ID) {
                <div class="st-create-topic-full-screen_content_main_options_property">
                    <span class="st-create-topic-full-screen_content_main_options_property__label">{{ item?.DefaultCaption }}</span>
                    <!-- handle special fields like topic status and tags -->
                    @if (item?.ID === pstFieldNames.PSTTopicType) {
                        <st-topic-type
                            class="st-create-topic-full-screen__topic-type"
                            showAdd
                            showRemove
                            required
                            [itemList]="globalTablesService.getListItemsForField(pstFieldNames.PSTTopicType)"
                            [label]="globalTablesService?.FieldDefsDict[pstFieldNames?.PSTTopicType]?.DefaultCaption"
                            [maxValuesToShow]="10"
                            [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTopicType]"
                            [value]="data()?.PSTTopicType"
                            (changed)="updateTopic($event, pstFieldNames.PSTTopicType)" />
                    } @else if (item?.ID === pstFieldNames.PSTTags) {
                        <st-tags-autocomplete
                            maxItemsToShow="10"
                            required
                            [value]="data()?.Tags"
                            [disabled]="topicDisabled() || data()?.readOnlyCriteria[pstFieldNames?.PSTTags]"
                            [label]="globalTablesService.FieldDefsDict[pstFieldNames?.PSTTags]?.DefaultCaption"
                            (changed)="updateTopic($event, pstFieldNames.PSTTags)" />
                    } @else {
                        @switch (item?.Validation?.toUpperCase()) {
                            @case ('TEXT') {
                                @if (item.WordWrap === false) {
                                    <st-text-field
                                        showLinks
                                        required
                                        [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                        [textToHighlight]="searchString$ | ngrxPush"
                                        [placeholder]="item.DefaultCaption"
                                        [value]="data()?.[item.ID]"
                                        (changed)="updateTopic($event, item.ID)" />
                                } @else {
                                    <st-text-area
                                        showLinks
                                        required
                                        [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                        [textToHighlight]="searchString$ | ngrxPush"
                                        [placeholder]="item.DefaultCaption"
                                        [value]="data()?.[item.ID]"
                                        (changed)="updateTopic($event, item.ID)" />
                                }
                            }
                            @case ('COMBOBOX') {
                                <st-combo-box
                                    required
                                    addEmptyOption
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [placeholder]="item.DefaultCaption"
                                    [value]="data()?.[item.ID]"
                                    [itemList]="itemListMap().get(item.ID)"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('CHECKLIST') {
                                <st-check-list
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [value]="data()?.[item.ID]"
                                    [data]="data()"
                                    [fieldName]="item.ID"
                                    [placeholder]="item.DefaultCaption"
                                    [itemList]="itemListMap().get(item.ID)"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('CHECKBOX') {
                                <st-check-box
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [placeholder]="item.DefaultCaption"
                                    [value]="data()?.[item.ID]"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('DATE') {
                                <st-date-picker
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [min]="item.ID === pstFieldNames.PSTTopicEventEndDate ? data()?.[pstFieldNames.PSTTopicEventStartDate] : null"
                                    [placeholder]="item.DefaultCaption"
                                    [value]="data()?.[item.ID]"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('TIME') {
                                <st-date-time-picker
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [min]="item.ID === pstFieldNames.PSTTopicEventEndDate ? data()?.[pstFieldNames.PSTTopicEventStartDate] : null"
                                    [placeholder]="item.DefaultCaption"
                                    [value]="data()?.[item.ID]"
                                    (onTimezoneChanged)="timezoneChanged(item.ID, $event)"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('MOSDATETIME') {
                                <st-date-time-picker
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [min]="item.ID === pstFieldNames.PSTTopicEventEndDate ? data()?.[pstFieldNames.PSTTopicEventStartDate] : null"
                                    [placeholder]="item.DefaultCaption"
                                    [value]="data()?.[item.ID]"
                                    (onTimezoneChanged)="timezoneChanged(item.ID, $event)"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('DATETIMERANGE') {
                                <st-date-time-range
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [placeholder]="item.DefaultCaption"
                                    [value]="data()?.[item.ID]"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('STAFFIDLIST') {
                                <st-staff-id-list-multiple
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [placeholder]="item.DefaultCaption"
                                    [value]="data()?.[item.ID]"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('TREE') {
                                <st-tree
                                    required
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [value]="data()?.[item.ID]"
                                    [placeholder]="item.DefaultCaption"
                                    [itemList]="globalTablesService.getlistItemsForTree(item.List)"
                                    [addEmptyOption]="!item.Required"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                            @case ('ADDRESS') {
                                @if (item.ComplexPropInnerId) {
                                    <st-text-field
                                        floating
                                        required
                                        [placeholder]="item.DefaultCaption"
                                        [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                        [textToHighlight]="searchString$ | ngrxPush"
                                        [value]="getInnerProp(item)"
                                        (changed)="updateTopicAddresSubField($event, item, item.ComplexPropInnerId)" />
                                } @else {
                                    <st-address-form
                                        required
                                        [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                        [placeholder]="item.DefaultCaption"
                                        [value]="data()?.[item.ID]"
                                        (changed)="updateTopic($event, item.ID)" />
                                }
                            }
                            @case ('COST') {
                                <st-special-cost
                                    required
                                    class="createTopic"
                                    [disabled]="item.ReadOnlyValue || data()?.readOnlyCriteria[item?.ID]"
                                    [columns]="globalTablesService.getListColumnsForSpecialField(item.ID)"
                                    [value]="data()?.[item.ID]"
                                    (changed)="updateTopic($event, item.ID)" />
                            }
                        }
                    }
                </div>
            }
        </div>
    </div>
    <mat-divider />
    <div class="st-create-topic-full-screen_content_footer">
        <div
            class="st-create-topic-full-screen_content_footer_buttons"
            [dir]="isRTL()">
            <button
                mat-button
                matRipple
                [matRippleRadius]="10"
                [disabled]="loading()"
                (click)="closeModal()">
                {{ languageSettings().PSTWebCancelButtonLabel }}
            </button>
            <button
                class="st-create-topic-full-screen_content_footer_buttons__create st-create-topic-full-screen_content_footer_buttons__create--save-and-close"
                mat-button
                matRipple
                [disabled]="disabled()"
                [matRippleRadius]="10"
                (click)="create(false)">
                @if (!loading()) {
                    {{ languageSettings().PSTWebSaveAndCloseButtonLabel }}
                } @else {
                    <st-loader
                        class="st-create-topic-full-screen-footer-buttons--spinner"
                        [diameter]="20"
                        [strokeWidth]="3" />
                }
            </button>
            <button
                class="st-create-topic-full-screen_content_footer_buttons__create"
                mat-button
                matRipple
                color="secondary"
                [matRippleRadius]="15"
                [disabled]="disabled()"
                (click)="create(true)">
                @if (!loading()) {
                    {{ languageSettings().PSTWebSaveAndContinueButtonLabel }}
                } @else {
                    <st-loader
                        class="st-create-topic-full-screen-footer-buttons--spinner"
                        [diameter]="20"
                        [strokeWidth]="3" />
                }
            </button>
        </div>
    </div>
</div>
